const loadJS = (src) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.addEventListener("load", () => {
      resolve(src);
    });
    script.addEventListener("error", () => {
      reject(src);
    });
    document.body.appendChild(script);
  });
};

export { loadJS };
